import {IStore} from "modules/types/store";

export const getMatchUpStore = (state: IStore) => state.matchUp;
export const getMatchUpSelector = (state: IStore) => state.matchUp.matchUp;
export const getMatchUpUserRanking = (state: IStore) => state.matchUp.currentUserRanking;
export const getMatchUpPlayersRankings = (state: IStore) => state.matchUp.rankings;
export const getMatchUpFilter = (state: IStore) => state.matchUp.filter;
export const getIsFetchedMatchUp = (state: IStore) => state.matchUp.isFetched;
